import React from 'react';
import { Box, ScopedCssBaseline } from '@mui/material';
import HtsCodeList from "./HtsCodeList";

// const fullTitle = 'Entry Summary';
// const shortTitle = fullTitle;
// const BCrumb = [
//   { title: "ABI" },
//   { title: shortTitle, },
// ];

function TablePage(props) {

  return (
    <ScopedCssBaseline>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem',
        }}
      >
        <HtsCodeList />
      </Box>
    </ScopedCssBaseline>);
};

export default TablePage;